import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PayStationLog } from 'src/features/payStations/types';
import type { ListDTO, ListResponse } from 'src/types';

const RESOURCE = '/paystation-logs/';

type QueryFnType = typeof queryFn;

const queryFn = ({ ...params }: ListDTO): Promise<ListResponse<PayStationLog>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useListAllPayStationLogs };
